<template>
	<section>
		<el-tabs v-model="activeName" type="card">
			<!--open list-->
			<el-tab-pane label="Working" name="first">
				<el-col :span="24" class="toolbar" style="padding-bottom: 0px;">
					<el-form :inline="true" :model="filters">
						<el-form-item>
							<el-input v-model="filters.workingFilter" placeholder="Product Name or UPC" clearable @keyup.enter.native="getWorkingOutboundList">
								<el-button slot="append" icon="el-icon-search" @click="getWorkingOutboundList"></el-button>
							</el-input>
						</el-form-item>
						<el-form-item>
							<el-input v-model="filters.workingMainFilter" placeholder="Main Product Name" clearable @keyup.enter.native="getWorkingOutboundList">
								<el-button slot="append" icon="el-icon-search" @click="getWorkingOutboundList"></el-button>
							</el-input>
						</el-form-item>
						<el-form-item>
							<el-button type="primary" @click="exportExcel('/excel/exportNurseOutbound','Working.xls',1)">Export</el-button>
						</el-form-item>
					</el-form>
				</el-col>

				<!--列表-->
				<el-table stripe :data="workingList" highlight-current-row v-loading="workingLoading" :row-class-name="tableRowClassName" style="width: 100%;">
					<el-table-column label="#" prop="outboundId">
					</el-table-column>
					<el-table-column  label="Outbound Shipment" >
						<template slot-scope="scope">
							<div v-html="scope.row.productName"></div>
						</template>
					</el-table-column>
					<el-table-column prop="company" label="Company"  >
					</el-table-column>
					<el-table-column prop="splitPackagesNum" label="Split Package Num" >
					</el-table-column>
					<el-table-column prop="instruction" label="Instruction"  >
						<template slot-scope="scope">
							<div v-html="scope.row.instruction"></div>
						</template>
					</el-table-column>
					<el-table-column label="Note">
						<template slot-scope="scope">
							<div v-html="scope.row.note"></div>
						</template>
					</el-table-column>
					<el-table-column prop="outboundDate" label="Last Update"  >
					</el-table-column>
					<el-table-column label="Action" width="300px">
						<template slot-scope="scope">
							<el-button size="small" type="primary"  @click="printNote(scope.row)">Print</el-button>
							<el-button size="small" type="primary" @click="download(scope.row.outboundId)">Package Label</el-button>
							<el-button size="small"  @click="archivedOutbound(scope.row.outboundId)">Archived</el-button>
						</template>
					</el-table-column>
				</el-table>

				<!--工具条-->
				<el-col :span="24" class="toolbar">
					<el-pagination layout="prev, pager, next" @current-change="changeWorkingList" :page-size="pageSize" :total="workingTotal"
								   style="float:right;">
					</el-pagination>
				</el-col>
			</el-tab-pane>
			<!--Groups list-->
			<el-tab-pane label="Archived" name="second">
				<el-col :span="24" class="toolbar" style="padding-bottom: 0px;">
					<el-form :inline="true" :model="filters">
						<el-form-item>
							<el-input v-model="filters.archivedFilter" clearable placeholder="Product Name or UPC" @keyup.enter.native="getArchivedOutboundList">
								<el-button slot="append" icon="el-icon-search" @click="getArchivedOutboundList"></el-button>
							</el-input>
						</el-form-item>
						<el-form-item>
							<el-input v-model="filters.archivedMainFilter" clearable placeholder="Main Product" @keyup.enter.native="getArchivedOutboundList">
								<el-button slot="append" icon="el-icon-search" @click="getArchivedOutboundList"></el-button>
							</el-input>
						</el-form-item>
						<el-form-item>
							<el-button type="primary" @click="exportExcel('/excel/exportNurseOutbound','Archived.xls',2)">Export</el-button>
						</el-form-item>
					</el-form>
				</el-col>

				<!--列表-->
				<el-table stripe :data="archivedList" highlight-current-row v-loading="archivedLoading" style="width: 100%;">
					<el-table-column label="#" prop="outboundId">
					</el-table-column>
					<el-table-column prop="outbound" label="Outbound Shipment"  >
						<template slot-scope="scope">
							<div v-html="scope.row.productName"></div>
						</template>
					</el-table-column>
					<el-table-column prop="company" label="Company"  >
					</el-table-column>
					<el-table-column prop="splitPackagesNum" label="Split Package Num" >
					</el-table-column>
					<el-table-column prop="instruction" label="Instruction"  >
						<template slot-scope="scope">
							<div v-html="scope.row.instruction"></div>
						</template>
					</el-table-column>
					<el-table-column label="Note">
						<template slot-scope="scope">
							<div v-html="scope.row.note"></div>
						</template>
					</el-table-column>
					<el-table-column prop="outboundDate" label="Last Update"  >
					</el-table-column>
					<el-table-column label="Action" width="300px">
						<template slot-scope="scope">
							<el-button size="small" type="primary"  @click="printNote(scope.row)">Print</el-button>
						</template>
					</el-table-column>
				</el-table>

				<!--工具条-->
				<el-col :span="24" class="toolbar">
					<el-pagination layout="prev, pager, next" @current-change="changeArchivedList" :page-size="pageSize" :total="archivedTotal" style="float:right;">
					</el-pagination>
				</el-col>
			</el-tab-pane>

		</el-tabs>

		<!--编辑界面-->
		<el-dialog title="Print" width="80%" :visible.sync="packageDetailVisible" :close-on-click-modal="false">
			<div id="printArea">
				<p><b>Outbound ID : {{print.outboundNo}}</b></p>
				<p><b>Company : {{print.company}}</b></p>
				<p><b>Outbound Shipment : </b></p>
				<div v-html="print.outboundShipment"></div>
				<p><b>Package Num : {{print.splitPackagesNum}}</b></p>
				<p><b>Instruction :</b></p>
				<div v-html="print.instruction"></div>
				<p><b>Note :</b></p>
				<div v-html="print.note"></div>
				<img id="barcode1" style="vertical-align:bottom; clear: both"/>
				<br/>
				<img id="barcode2" style="vertical-align:bottom; clear: both"/>
				<br/>
				<img id="barcode3" style="vertical-align:bottom; clear: both"/>
				<br/>
				<img id="barcode4" style="vertical-align:bottom; clear: both"/>
				<br/>
				<img id="barcode5" style="vertical-align:bottom; clear: both"/>
				<br/>
				<img id="barcode6" style="vertical-align:bottom; clear: both"/>
			</div>
		</el-dialog>
	</section>
</template>


<script>
	import {updateOutboundStatus,getOutboundList} from "../../api/outboundService";
	import ElButton from "element-ui/packages/button/src/button";
	import ElLink from "element-ui/packages/link/src/main";
	import ElOption from "element-ui/packages/select/src/option";
	import ElInput from "element-ui/packages/input/src/input";
    import {defaultPageSize,serverUrl} from "../../globalVar";
	import {postExportExcel} from "../../api/exportService";
	import JsBarcode from 'jsbarcode'

	export default {
		components: {
			ElInput,
			ElOption,
			ElLink,
			ElButton},
		created(){
			this.$on('changeDoctor',(value) => {
				setTimeout(()=>{
					this.getWorkingOutboundList();
					this.getArchivedOutboundList();
				},300);
			});
		},
        data() {
			return {
				currentCompany:"",
				activeName:"first",
				filters: {
					workingFilter:"",
					workingMainFilter:"",
					archivedFilter:"",
                    archivedMainFilter:"",
					name: ''
				},

				pageSize:defaultPageSize,

				workingList:[],
				workingPage:1,
				workingTotal:0,
				workingLoading:false,

				archivedList:[],
				archivedPage:1,
				archivedTotal:0,
				archivedLoading:false,

				workingOutboundList: [],
				archivedOutboundList:[],
				total: 0,
				page: 1,
				listLoading: false,
				editMemberObj:{},
				packageDetailVisible: false,//编辑界面是否显示
				addGroupVisible:false,
				invitationVisible:false,
				editLoading: false,
				editFormRules: {
					name: [
						{ required: true, message: '请输入姓名', trigger: 'blur' }
					]
				},
				print:{
                    instruction:"",
					note:"",
					outboundNo:"",
					outboundShipment:"",
					splitPackagesNum: 1,
					company:"",
					upcs:""
				},
				//编辑界面数据
				editForm: {
					id: 0,
					name: '',
					sex: -1,
					age: 0,
					birth: '',
					addr: ''
				},
				detail:{},
				addFormVisible: false,//新增界面是否显示
				addLoading: false,
				addFormRules: {
					name: [
						{ required: true, message: '请输入姓名', trigger: 'blur' }
					]
				},
				//新增界面数据
				member: {
					id:"",
					userName:"",
					email:"",
					phone:"",
					status:"",
					pendingTransaction:7,
					pendingAmount:""
				},
				group:{
					id:'',
					groupName:"",
					users:[],
					pendingTransaction:7,
					pendingAmount:""
				},
				invitation:{
					id:"",
					email:"",
					status:"",
					dateTime:"",
					role:""
				}

			}
		},
		methods: {
			exportExcel(url,fileName,type){
				let param = {
					url:url,
					fileName:fileName,
					doctorNo:window.sessionStorage.getItem("currentCompany"),
					status:type
				}
				postExportExcel(param).then(function(){

				})
			},
			archivedOutbound(id){
				this.$confirm('Are you sure?', 'Warning', {
					type: 'warning'
				}).then(()=>{
					let param = {
						outboundNo:id,
						status:2
					};
					updateOutboundStatus(param).then((data)=>{
						if(data.status===200){
							this.$message.success(data.message);
							this.getWorkingOutboundList();
							this.getArchivedOutboundList();
						}else{
							this.$message.error(data.message)
						}
					})
				}).catch(()=>{})
			},
			download(id){
				window.open(serverUrl+"/outboundFile/exportPackageLabelImageById?outboundNo="+id,"_blank")
			},
			tableRowClassName({row, rowIndex}) {
				if (row.priority === 2) {
					return 'urgent-row';
				} else if (row.priority === 1) {
					return 'Medium-row';
				}
				return "";
			},
		    packageDetail(row){
		        this.detail = row;
		        this.packageDetailVisible = true;
			},
			changeWorkingList(val){
				this.workingPage = val;
				this.getWorkingOutboundList();
			},
			getWorkingOutboundList(){
				let param = {
					current:this.workingPage,
					size:this.pageSize,
					status:1,
					condition:this.filters.workingFilter,
					doctorNo:window.sessionStorage.getItem("currentCompany"),
					main:this.filters.workingMainFilter
				}
				this.workingLoading = true;
				getOutboundList(param).then((data)=>{
					this.workingLoading = false;
					if(data.status===200){
						this.workingList = data.result.records;
						this.workingTotal = data.result.total;
					}
				})
			},
			changeArchivedList(val){
				this.archivedPage = val;
				this.getArchivedOutboundList();
			},
			getArchivedOutboundList(){
				let param = {
					current:this.archivedPage,
					size:this.pageSize,
					status:2,
					condition:this.filters.archivedFilter,
					doctorNo:window.sessionStorage.getItem("currentCompany"),
					main:this.filters.archivedMainFilter
				}
				this.archivedLoading = true;
				getOutboundList(param).then((data)=>{
					this.archivedLoading = false;
					if(data.status===200){
						this.archivedList = data.result.records;
						this.archivedTotal = data.result.total;
					}
				})
			},
			printNote(row){
			    this.print.instruction = row.instruction;
			    this.print.upcs = row.upcs;
                this.print.note = row.note;
                this.print.outboundNo = row.outboundId;
                this.print.company = row.company;
                this.print.outboundShipment = row.productName;
                this.print.splitPackagesNum = row.splitPackagesNum;
                this.packageDetailVisible = true;

				setTimeout(()=>{
					$("#barcode1").attr('src', '');
					$("#barcode2").attr('src', '');
					$("#barcode3").attr('src', '');
					$("#barcode4").attr('src', '');
					$("#barcode5").attr('src', '');
					$("#barcode6").attr('src', '');
					if (this.print.upcs) {
						this.print.upcs.split("<br>").forEach(function (item, index) {
							let barHeight = 18;
							let svgId = "#barcode" + (index + 1);
							if (item) {
								JsBarcode(svgId, item, {
									format:"CODE128",//条形码的格式
									width:1,//线宽
									height:barHeight,//条码高度
									lineColor:"#000",//线条颜色
									displayValue: false,//是否显示文字
									margin:2//设置条形码周围的空白区域
								})
							}
						});
					}

					let element = document.getElementById("printArea")
                    this.$print(element)
                    this.packageDetailVisible = false;
				},800)

			}
		},
		mounted() {
			this.getWorkingOutboundList();
			this.getArchivedOutboundList();
		}
	}

</script>
<style>
	.urgent-row{
		color: red;
	}
</style>


// WEBPACK FOOTER //
// outbound.vue?bf0e3642